import { render, staticRenderFns } from "./TheDepartmentSelector.vue?vue&type=template&id=6393c2b4&scoped=true&"
import script from "./TheDepartmentSelector.vue?vue&type=script&lang=ts&"
export * from "./TheDepartmentSelector.vue?vue&type=script&lang=ts&"
import style0 from "./TheDepartmentSelector.vue?vue&type=style&index=0&id=6393c2b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6393c2b4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
